@if (deviceCardData() && deviceCardData().length) {
  @let device = deviceCardData()[0];
  <section class="f-column gap-1">
    <aos-device-card
      [device]="device"
      [showComment]="true"
    ></aos-device-card>

    <section class="program-mtu">
      <div class="program-mtu__header">
        <h6>{{ 'INSTALLATIONS_SIDE_PANEL.BLOCK.PROGRAM_MTU' | translate }}</h6>
      </div>
      <div class="program-mtu__values-block f-column gap-025">
        <p class="flex">
          <span class="program-mtu__values-block__label"
            >{{ 'INSTALLATIONS_SIDE_PANEL.LABEL.READ_INTERVAL' | translate }}:</span
          >
          <span>{{ getReadIntervalText(device) }}</span>
        </p>
        <p class="flex">
          <span class="program-mtu__values-block__label"
            >{{ 'INSTALLATIONS_SIDE_PANEL.LABEL.F1_FREQUENCY' | translate }}:</span
          >
          <span>{{ getAttrOrDash(device, this.OneWayTxFreq) }}</span>
        </p>
        <p class="flex">
          <span class="program-mtu__values-block__label"
            >{{ 'INSTALLATIONS_SIDE_PANEL.LABEL.F2_FREQUENCY' | translate }}:</span
          >
          <span>{{ getAttrOrDash(device, this.TwoWayTxFreq) }}</span>
        </p>
      </div>
    </section>

    @if (device.associatedDevices?.length) {
      <h5>{{ 'DEVICE_DETAILS.ASSOC_SIDE_CARD.ASSOCIATED_DEVICES' | translate }}</h5>
      @for (assoc of device.associatedDevices; track $index) {
        <aos-device-card
          [device]="assoc"
          [showComment]="true"
        ></aos-device-card>
      }
    }
  </section>
}
